import Cookies from 'universal-cookie'
import { tokenKey } from '../api-client/client'

export default function protectRoutes({ appContext, isProtected }) {
  const cookiesToken = new Cookies(appContext?.ctx?.req?.headers?.cookie ?? '').get(tokenKey)
  const queryStringBearerToken = appContext?.ctx?.query?.bearer
  const isTokenProvided = cookiesToken || queryStringBearerToken
  const isClientSideRendering = typeof window !== 'undefined'

  if (!isProtected || (isProtected && isTokenProvided)) return

  if (isClientSideRendering) {
    const params = new URLSearchParams({ authModal: 'login', authRedirect: appContext.ctx.asPath })
    return appContext.router.push(`/?${params}`)
  }

  const params = new URLSearchParams({ authModal: 'login', authRedirect: appContext.ctx.req.url })

  appContext.ctx.res.writeHead(307, { Location: `/${appContext.ctx.req.locale}?${params}` }).end()
}
